import React from "react";

function Loader() {
  return <div className=" loader-rotate shadow-md "></div>;
}

export default Loader;
